import React, {useContext, useEffect, useRef, useState} from 'react';
import RecaptchaEnterprise from "../../components/recaptcha/RecaptchaEnterprise";
import DisponibilidadService from "../../services/DisponibilidadService";
import './ConsultaDisponibilidad.css';
import {ConsultaDisponibilidadContentResponse} from "./ConsultaDisponibilidadContentResponse";
import {SidebarComponent} from "../../components/sidebar/SidebarComponent";
import {Bienvenida} from "../../Bienvenida";
import AppContext from "../../store/AppContext";
import RegistroDominioService from "../../services/RegistroDominioService";
import {getOidcState} from "../../security/OidcManager";
import {useLocation} from "react-router-dom";
import {TipoMensaje} from "../../store/AppProvider";
import CarritoService from "../../services/CarritoService";

const REACT_APP_SITE_KEY = process.env.REACT_APP_SITE_KEY;
const MENSAJE_DOMINIO_INVALIDO = 'El nombre del dominio solo puede contener letras, números y guiones (-). Ingrese solo el nombre, sin extensión.';
const DOMINIO_LABEL_REGEX = /^[a-zA-Z0-9áéíóúüñÁÉÍÓÚÜÑ-]+$/;
export const ConsultaDisponibilidadContent = () => {
    const appCtx = useContext(AppContext);
    const recaptchaRef = useRef();
    const captchaRequeridoPorBackendRef = useRef(false);
    const [nombreDominio, setNombreDominio] = useState('');
    const [resultadoDisponibilidadDominio, setResultadoDisponibilidadDominio] = useState(undefined);
    const [dominioBuscadoDisponible, setDominioBuscadoDisponible] = useState(false);
    const [listaDominios, setlistaDominio] = useState([]);
    const [checked, setChecked] = useState(listaDominios);
    const [captchaResponse, setCaptchaResponse] = useState('');
    const [showCaptcha, setShowCaptcha] = useState(true);
    const [loading, setLoading] = useState(false);
    const [mensajeCarritoExpirado, setMensajeCarritoExpirado] = useState('');
    const location = useLocation();

    const uuidVenta = appCtx?.venta?.uuidVenta;
    useEffect(() => {
        if (uuidVenta && getOidcState().is_authenticated) {
            RegistroDominioService.asociarUsuarioAVenta(uuidVenta).then();
        }
    }, [uuidVenta]);

    useEffect(() => {
        if (appCtx.venta !== undefined && appCtx.venta.uuidVenta !== undefined && appCtx.venta.uuidVenta !== "") {
            refreshCarrito();
        }
        mostrarCaptcha();
        if (location.state?.dominioDisponibilidadWhoIs) {
            let dominioDisponibilidadWhoIs = location.state.dominioDisponibilidadWhoIs;
            let wcv = location.state.wcv;
            const arrayDominio = dominioDisponibilidadWhoIs.split(".");
            let tld;
            if (arrayDominio.length > 2) {
                tld = '.' + arrayDominio[1] + '.' + arrayDominio[2];
            } else {
                tld = '.' + arrayDominio[1];
            }
            const nombreSinTLD = arrayDominio[0];
            setNombreDominio(nombreSinTLD);

            setChecked([tld]);
            consultaDisponibilidad(dominioDisponibilidadWhoIs, tld, wcv);
            obtenerDominiosHabilitados(false);
        } else {
            obtenerDominiosHabilitados(true);
        }
        if (location.state?.mensajeCarritoExpirado) {
            setMensajeCarritoExpirado(location.state.mensajeCarritoExpirado);
            appCtx.mostrarMensaje(location.state.mensajeCarritoExpirado, TipoMensaje.warning);
        } else {
            appCtx.ocultarMensaje();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const consultarDisponibilidadSubmit = (e) => {
        e.preventDefault();

        const dominio = eliminarEspacios(nombreDominio || '');
        if (!dominio) {
            appCtx.mostrarMensaje('Ingrese el nombre del dominio que desea consultar.', TipoMensaje.warning);
            return;
        }
        if (!DOMINIO_LABEL_REGEX.test(dominio)) {
            appCtx.mostrarMensaje(MENSAJE_DOMINIO_INVALIDO, TipoMensaje.warning);
            return;
        }

        setNombreDominio(dominio);
        consultaDisponibilidad(dominio, '', showCaptcha);
    };

    const consultaDisponibilidad = (dominio, tld, wcv) => {
        if (showCaptcha && !captchaResponse) {
            appCtx.mostrarMensaje('Debe completar el captcha.', TipoMensaje.error);
            return;
        }

        let arregloDominios = [];
        let tlds = checked;
        const dominoConsulta = dominio.toLowerCase();
        setNombreDominio(dominoConsulta);

        if (tld !== '') {
            tlds = [];
            tlds.push(tld);
        } else {
            if (checked.length === 0) {
                tlds = listaDominios;
            }
        }

        for (let index = 0; index < tlds.length; index++) {
            arregloDominios.push(dominoConsulta + tlds[index]);
        }

        setLoading(true);
        DisponibilidadService.getDisponibilidad(arregloDominios, captchaResponse, wcv)
            .then((response) => {
                if (showCaptcha && recaptchaRef.current) {
                    recaptchaRef.current.reset();
                }

                setCaptchaResponse(''); // limpiar respuesta
                if (!response) {
                    appCtx.mostrarMensaje('Lo sentimos, ha ocurrido un error. Por favor, inténtelo nuevamente.', TipoMensaje.error);
                    setResultadoDisponibilidadDominio(undefined);
                    mostrarCaptcha();
                    return;
                }

                if (response.respuestaOK) {
                    captchaRequeridoPorBackendRef.current = false;
                    appCtx.ocultarMensaje();

                    let disponible = false;
                    for (let index = 0; index < response.dominioDisponibilidadDTO.length; index++) {
                        if (!disponible) {
                            disponible = response.dominioDisponibilidadDTO[index].disponible;
                        }
                    }

                    setDominioBuscadoDisponible(disponible);
                    setResultadoDisponibilidadDominio(response.dominioDisponibilidadDTO);

                    // refrescar visibilidad del captcha
                    mostrarCaptcha();
                }
                else if (response.respCodigo === 'CAPTCHA_INVALIDO') {
                    appCtx.mostrarMensaje('El captcha no se validó correctamente. Inténtelo nuevamente.', TipoMensaje.error);
                    setResultadoDisponibilidadDominio(undefined);
                    mostrarCaptcha();
                }
                else if (response.respCodigo === 'CAPTCHA_REQUERIDO') {
                    captchaRequeridoPorBackendRef.current = true;
                    appCtx.mostrarMensaje('Es necesario validar el captcha para continuar.', TipoMensaje.warning);
                    setShowCaptcha(true);
                    setResultadoDisponibilidadDominio(undefined);
                }
                else if (response.respCodigo === 'DOMINIO_INVALIDO') {
                    appCtx.mostrarMensaje(response.mensaje, TipoMensaje.warning);
                    setResultadoDisponibilidadDominio(undefined);
                }
                else {
                    appCtx.mostrarMensaje(response.mensaje || 'Lo sentimos, ha ocurrido un error. Por favor, inténtelo nuevamente.', TipoMensaje.error);
                    setResultadoDisponibilidadDominio(undefined);
                    mostrarCaptcha();
                }
            })
            .catch(() => {
                appCtx.mostrarMensaje('Lo sentimos, ha ocurrido un error. Por favor, inténtelo nuevamente.', TipoMensaje.error);
                setResultadoDisponibilidadDominio(undefined);
                if (showCaptcha && recaptchaRef.current) {
                    recaptchaRef.current.reset();
                }
                setCaptchaResponse('');
                mostrarCaptcha();
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const obtenerDominiosHabilitados = (chequear) => {
        DisponibilidadService.getDominiosHabilitados().then((response) => {
            if (response && response.respuestaOK) {
                let domsHabilitados = [];
                for (let index = 0; index < response.dominiosHabilitados.length; index++) {
                    domsHabilitados.push(response.dominiosHabilitados[index]);
                }
                setlistaDominio(domsHabilitados);
                if (chequear){
                    setChecked(domsHabilitados);
                }
            }
        })
    }

    const mostrarCaptcha = () => {
        if (captchaRequeridoPorBackendRef.current) {
            setShowCaptcha(true);
            return;
        }
        DisponibilidadService.mostrarCaptcha().then(response => {
            if (response !== undefined) {
                if (response.codigo === 'OK') {
                    setShowCaptcha(response.resultado);
                }
            }
        })
    }

    const refreshCarrito = () => {
        CarritoService.refrescarVentaCarrito(appCtx.venta.uuidVenta).then(response => {
            if (response && response.stale) {
                return;
            }
            if (response && response.respuestaOK) {
                appCtx.refrescarCarrito(response.registrosPendientes, response.renovacionesPendientes, response.transferenciasTitularesPendientes);
            }
        })
    }

    const handleOnChange = (event) => {
        let updatedList = [...checked];
        if (!event.target.checked) {
            updatedList.splice(checked.indexOf(event.target.id), 1);
        } else {
            updatedList = [...checked, event.target.id];
        }
        setChecked(updatedList);
    };

    const handleOnChangeText = (e) => {
        const { value } = e.target;
        setNombreDominio(value);
    }

    function onChange(value) {
        setCaptchaResponse(value);
    }

    function eliminarEspacios(cadena) {
        return cadena.replace(/\s/g, '');
    }

    return <>
        {mensajeCarritoExpirado && (
            <div className="message-box" id="register-warning">
                <h3>
                    <ul className="actionMessage">
                        <li><span>{mensajeCarritoExpirado}</span></li>
                    </ul>
                </h3>
            </div>
        )}
        <div className="box-domain">
            <form id="id-form-availability-query" onSubmit={ consultarDisponibilidadSubmit } >
                <div style={{position: "relative"}}>
                    <label htmlFor="domain-txt">Consultar disponibilidad:</label>
                    <input id="domain-txt" type="text" name="dominio" maxLength={50} value={nombreDominio}
                           placeholder="Nombre del dominio" onChange={handleOnChangeText} />
                    <div id="div-watermark" className="domain-txt-label" style={{display: "none"}}>Nombre del dominio</div>
                    <input type="submit" value="Buscar" disabled={loading}/>
                </div>
                <div className="domain-tips">
                    {listaDominios.length > 0 ?
                        listaDominios.map((item, index) => (
                            <div key={index} className={"domain-tips-inline"}>
                                <input id={item} className={"checkbox-space"} type="checkbox" checked={checked.includes(item)} onChange={handleOnChange}/>
                                <label htmlFor={item}>{item}</label>
                            </div>
                        ))
                        :
                        <div key={0} className={"domain-tips-inline"}>
                        </div>
                    }
                </div>
                { showCaptcha &&
                    <div className={"box-captcha cfx"}>
                        <RecaptchaEnterprise
                            ref={recaptchaRef}
                            siteKey={REACT_APP_SITE_KEY}
                            action="DISPONIBILIDAD"
                            onChange={onChange}
                        />
                    </div>
                }
            </form>
        </div>

        { resultadoDisponibilidadDominio?
            <ConsultaDisponibilidadContentResponse resultadoDominios={resultadoDisponibilidadDominio} dominioBuscadoDisponible={dominioBuscadoDisponible} />
            :
            <>
                <Bienvenida/>
                <SidebarComponent/>
            </>
        }

    </>
}